import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { OnProductionLineView } from "src/components/views/erp/production/onProductionLine/OnProductionLineView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/production/onProductionLine")({
	staticData: { title: i18n.t("on_production_line"), legacyViewKey: "onProductionLineView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <OnProductionLineView />;
}
